module.exports = __webpack_public_path__ + "img/1454857900.3f6e4167.jpg";